<script setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },
  text: {
    type: String,
    default: undefined,
  },
  buttonText: {
    type: String,
    default: undefined,
  },
});
const { t } = useI18n();

function handleClick() {
  window.location.reload();
}
</script>

<template>
  <ModalBase class="modals-alert" hide-header>
    <div class="modals-alert__container">
      <div class="modals-alert__title">
        <span class="modals-alert__font modals-alert__font--title">
          {{ title || t('common.error') }}
        </span>
      </div>

      <div v-if="text" class="modals-alert__text">
        <p class="modals-alert__font modals-alert__font--text">
          {{ text }}
        </p>
      </div>

      <UiButton
        class="modals-alert__button"
        type="button"
        theme="purple"
        @click="handleClick"
      >
        <span class="modals-alert__font modals-alert__font--button">
          {{ buttonText || t('common.reloadPage') }}
        </span>
      </UiButton>
    </div>
  </ModalBase>
</template>

<style scoped lang="scss">
.modals-alert {
  &__font {
    display: block;

    &--title {
      font-size: em(20);
      font-weight: 500;
    }

    &--text {
      font-size: em(14);
      line-height: math.div(17, 14);
    }

    &--button {
      font-size: em(20);
      font-weight: 500;
      line-height: math.div(22, 20);
    }
  }

  &__container {
    padding: em(39) em(23) em(24);

    @include media-breakpoint-down(sm) {
      padding: em(43) em($gap-sm) em(33);
    }
  }

  &__title {
    margin-bottom: em(27);
    text-align: center;
  }

  &__text {
    padding: em(10) em(15);
    margin-bottom: em(31);
    color: $color-yellow-2;
    text-align: center;
    background-color: $color-yellow-3;
    border: 1px solid $color-yellow-2;
    border-radius: em(10);
  }

  &__button {
    width: em(358);
    height: em(63);
    margin: 0 auto;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }
}
</style>
